import { Reducer } from "redux";
import { createReducer, ActionType } from "typesafe-actions";

import { dashboardViewKeys } from "app/constants/erd-dashboard";

import { IDsDashboardState } from "./types";
import * as dsDashboardActions from "./actions";

type UserAction = ActionType<typeof dsDashboardActions>;

const initialState: IDsDashboardState = {
    selectedDeleteTable: null,
    selectedEditTable: null,
    activeDashboardViews: [dashboardViewKeys.ERD_VIEW],
    dashboardKey: 0, // key given so react reads split as a new element on every re-render
    codeViewData: null,
    jsonViewData: null,
    erdViewData: null,
    protobufViewData: null,
    generatedProtobufData: ``,
    sqlViewData: null
    // check: false
};

const dsDashboardReducer: Reducer<IDsDashboardState, UserAction> = createReducer<IDsDashboardState>(initialState)
    .handleAction(dsDashboardActions.setSelectedDeleteTable,
        (state: IDsDashboardState, action: UserAction) => ({ ...state, selectedDeleteTable: action.payload }))
    .handleAction(dsDashboardActions.setSelectedEditTable,
        (state: IDsDashboardState, action: UserAction) => ({ ...state, selectedEditTable: action.payload }))
    .handleAction(dsDashboardActions.setActiveDashboardViews,
        (state: IDsDashboardState, action: UserAction) => {
            const updatedActiveDashboardViews: string[] = [...state.activeDashboardViews];
            if (updatedActiveDashboardViews.includes(action.payload)) {
                const indexOfValue = updatedActiveDashboardViews.indexOf(action.payload);
                updatedActiveDashboardViews.splice(indexOfValue, 1);
            } else {
                updatedActiveDashboardViews.push(action.payload);
            }

            return { ...state, dashboardKey: Math.random(), activeDashboardViews: updatedActiveDashboardViews };
        })
    .handleAction(dsDashboardActions.setDashboardViewData,
        (state: IDsDashboardState, action: UserAction) => {
            if (action.payload.type === dashboardViewKeys.CODE_VIEW) return { ...state, codeViewData: action.payload.data };
            if (action.payload.type === dashboardViewKeys.JSON_VIEW) return { ...state, jsonViewData: action.payload.data };
            if (action.payload.type === dashboardViewKeys.ERD_VIEW) return { ...state, erdViewData: action.payload.data };
            if (action.payload.type === dashboardViewKeys.PROTOBUF_VIEW) return { ...state, protobufViewData: action.payload.data };
            if (action.payload.type === dashboardViewKeys.SQL_VIEW) return { ...state, sqlViewData: action.payload.data };

        })
    .handleAction(dsDashboardActions.setErdViewMetaData,
        (state: IDsDashboardState, action: UserAction) => ({ ...state, erdViewMetaData: action.payload }))
    .handleAction(dsDashboardActions.setGeneratedProtobufData,
        (state: IDsDashboardState, action: UserAction) => ({ ...state, generatedProtobufData: action.payload }))
    .handleAction(dsDashboardActions.setSqlViewData,
        (state: IDsDashboardState, action: UserAction) => ({ ...state, setSqlViewData: action.payload }));
// .handleAction(dsDashboardActions.setSqlViewData,
//         (state: IDsDashboardState, action: UserAction) => ({ ...state, sqlViewData: action.payload }));

export default dsDashboardReducer;
